// extracted by mini-css-extract-plugin
export var completionBody = "_kk-2";
export var completionCard = "_kk-0";
export var completionFooter = "_kk-3";
export var completionTitle = "_kk-1";